export const formatMoney = (value) => {
  const num = Number(value || 0);
  return num.toLocaleString("en-NZ", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatHours = (value) => {
  if (value === "-") return "-";
  return Number(value || 0).toFixed(2);
};

export const formatDate = (date) => {
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const formatPayoutDate = (value) => {
  if (!value) return "";

  const date =
    typeof value?.toDate === "function" ? value.toDate() : new Date(value);

  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleDateString("en-GB", {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

// "2026-07-28" -> "Mon 28/07"
export const formatShiftDay = (isoDate) => {
  if (!isoDate) return "";
  const [year, month, day] = String(isoDate).split("-").map(Number);
  const date = new Date(year, (month || 1) - 1, day);
  if (Number.isNaN(date.getTime())) return String(isoDate);
  const weekday = date.toLocaleDateString("en-GB", { weekday: "short" });
  return `${weekday} ${String(day).padStart(2, "0")}/${String(month).padStart(2, "0")}`;
};

// Check-in/out timestamp (epoch seconds) -> "8:00 AM" in NZ time
export const formatShiftTime = (seconds) => {
  if (seconds === null || seconds === undefined || seconds === "") return "-";
  const date = new Date(Number(seconds) * 1000);
  if (Number.isNaN(date.getTime())) return "-";
  return date
    .toLocaleTimeString("en-NZ", {
      timeZone: "Pacific/Auckland",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })
    .toUpperCase();
};

export const formatPdfMoney = (value) => {
  const num = Number(value || 0);
  const formatted = Math.abs(num).toLocaleString("en-NZ", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return num < 0 ? `-$${formatted}` : `$${formatted}`;
};
